import {
    Button,
    GlanceLoader,
    Tooltip,
    Alert,
  } from '../ui-components';
  import React from 'react';

function SessionLookupState({onCancel, gicon}) {

    return (
        <div className='SizeWrapper'>
            <div className='buttonAndTextWrapper'>
                <div className='rowAlign'>
                    { gicon && <div className='Spinner'>
                        <GlanceLoader size="12" spinning={true}></GlanceLoader>
                      </div> }
                    <span className="wrapper" style={{ display: "inline-block" }}>
                    <Tooltip text="Stop request" offset={8} size="small">
                    <Button size="small" variant="secondary" shape="rounded-full" animation="false" onClick={()=>(typeof(onCancel) === typeof(Function)) ? onCancel() : console.log("Cancel pressed")}>Cancel</Button>
                    </Tooltip>
                    </span>
                </div>
                <div className='AlertWrapper'>
                    <Alert size="small" severity="info" variant="open" heading="Waiting for visitor to connect" closable="false" /> 
                </div>
            </div>  
        </div>
        
        
    );
}

export default SessionLookupState;